<template>
  <div class="col-span-6" v-bind:class="'sm:col-span-' + columns">
    <ValidationProvider :rules="rules" v-slot="v">
      <label class="block text-sm font-medium leading-5 text-gray-700">
        {{ label }}
        <span class="text-xs text-red-500" v-if="rules && rules.includes('required')">*</span>
        <span
          v-show="tooltip"
          :data-tooltip="tooltip"
          class="ml-1 inline-flex items-center px-1.5 rounded-full text-xs font-normal leading-4 bg-gray-100 text-gray-800"
        >?</span>
      </label>
      <input
        type="file"
        @change="onChange"
        :accept=accept
        :class="v.errors[0] ? 'bg-pink-50' : ''"
        class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
      />
      <span class="text-xs text-red-500" v-if="v.errors[0]">{{ v.errors[0] }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  name: "file-upload",
  props: {
    label: String,
    tooltip: String,
    columns: String,
    rules: String,
    maxSize: Number,
    accept: String,
  },

  data: function() {
    return {
    };
  },

  computed: {},

  methods: {
     onChange(e) {
      const files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        return;
      }

      const file = files[0];
      const size = file.size && (file.size / Math.pow(1000, 2));

      if (size > this.maxSize) {
        this.$emit('size-exceeded', size);
        return;
      }

      this.file = file;
      this.$emit('metadata', file);

      const reader = new FileReader();

      reader.onload = e => {
        const dataURI = e.target.result;

        if (dataURI) {
          this.$emit('fileloaded', dataURI.split(',')[1]);
        }
      };

      reader.readAsDataURL(file);
    }
  }
};
</script>

<style scoped>
[data-tooltip]:hover {
  position: relative;
}
[data-tooltip]:hover::before {
  all: initial;
  font-family: Arial, Helvetica, sans-serif;
  display: inline-block;
  border-radius: 5px;
  padding: 10px;
  background-color: #777;
  content: attr(data-tooltip);
  color: #f9f9f9;
  position: absolute;
  bottom: 100%;
  width: 300px;
  left: 50%;
  transform: translate(-50%, 0);
  margin-bottom: 15px;
  text-align: center;
  font-size: 14px;
}
</style>